/**
 * Database test result interface
 */
export interface DatabaseTestResult {
  success: boolean;
  message: string;
  data?: any;
  error?: {
    code?: string;
    message?: string;
    details?: string;
    hint?: string;
    [key: string]: any;
  };
}

/**
 * Database table names
 */
export enum DatabaseTable {
  PROFILES = 'profiles',
  TEMPLATES = 'templates',
  FORECASTING_PROCESS = 'forecasting_process'
}

/**
 * Database query options
 */
export interface QueryOptions {
  limit?: number;
  offset?: number;
  orderBy?: string;
  ascending?: boolean;
  filters?: QueryFilter[];
}

/**
 * Database query filter
 */
export interface QueryFilter {
  column: string;
  operator: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte' | 'like' | 'ilike' | 'is' | 'in';
  value: any;
}

/**
 * Database record status
 */
export enum RecordStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED', 
  REJECTED = 'REJECTED',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}